import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalContext";
import { Mail, LogOut, Trash } from "lucide-react";
import { images } from "../Assets/images";
import storage from "../Assets/js/Global";

const PlanExpired = () => {
    const navigate = useNavigate();
    const { logoUrl, translatedLabels, is4Life } = useContext(GlobalContext);
    const commonLabels = translatedLabels?.common;

    const handleLogout = () => {
        storage.remove("accessToken");
        storage.remove("refreshToken");
        storage.remove("loginObj");
        storage.set("isLoggedIn", false);
        navigate("/login");
    };

    return (
        <div className="container-fluid h-100 d-flex flex-colum align-items-center justify-content-center" style={{ background: '#f5f6fa', minHeight: '100vh' }}>
            <div className="">
                <div className="" style={{ borderRadius: '16px', border: 'none' }}>
                    <div className="card-body text-center p-4 p-md-5">
                        {/* Logo */}
                        <div className="mb-4 mb-md-5">
                            <img
                                src={logoUrl || images.appLogo}
                                alt="app-logo"
                                className="img-fluid"
                                style={{ maxWidth: "140px", height: "auto" }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = images.appLogo;
                                }}
                            />
                        </div>

                        {/* Content */}
                        <h3 className="fw-bold mb-3 mb-md-4" style={{ color: "var(--headingColor)", fontSize: "clamp(1.25rem, 4vw, 1.75rem)" }}>
                            {commonLabels?.plan_expired_title?.label_value || "Your 4Life Plan Has Expired"}
                        </h3>
                        <p className="text-muted mb-1 mb-md-5 px-2 px-md-3" style={{ fontSize: "clamp(0.875rem, 3vw, 1rem)", lineHeight: "1.6" }}>
                            {commonLabels?.plan_expired_desc?.label_value ||
                                "Your 4Life membership has expired. Renew now to continue enjoying your health insights, scans, and premium features."}
                        </p>

                        {/* Actions */}
                        <div className="d-grid gap-3 gap-md-4">
                            {/* <h3
                                    className="w-100 d-flex align-items-center justify-content-center gap-2 py-0 mb-0"
                                    style={{ borderRadius: "12px", fontWeight: "600", minHeight: "20px", fontSize: "clamp(0.875rem, 2.5vw, 1rem)" }}
                                >
                                    <Mail size={18} />
                                    {"support@healthy4life.ai"}
                                </h3> */}

                            <div className="d-flex gap-3 justify-content-center align-items-center mt-3">
                                <Link to='https://4l.shop/scan' target="blank" className="btn btn-primary">{commonLabels?.renew_plan?.label_value || "Renew Plan"}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlanExpired;